/**
 * Gated Onboarding Screen
 * Shown when clinic has no patients yet (first_upload_at === null)
 * No navigation visible - they must upload to proceed
 */

import React from 'react';
import OnboardingWizard from './OnboardingWizard';

const GatedOnboarding = ({ onComplete }) => {
  return <OnboardingWizard onComplete={onComplete} />;
};

export default GatedOnboarding;
